import { Ref } from 'react'

import { InputProps } from '~/bootcamp/Activities/types/activities.types'

import Input from './Input'

interface InputNumbersOnlyProps extends Omit<InputProps, 'type'> {
  inputRef?: Ref<HTMLInputElement | null>
}

const InputNumbersOnly = (props: InputNumbersOnlyProps): React.ReactElement => {
  const { onChange, ...rest } = props

  const handleOnChange = (value: string, name: string): void => {
    const numbers = '0123456789'
    if (!value.length || numbers.includes(value[value.length - 1])) {
      onChange(value, name)
    }
  }

  return <Input {...rest} onChange={handleOnChange} type="text" />
}

export default InputNumbersOnly
